import React, { FC } from "react";
import styles from "./products-slider-skin-2.module.css";
import {
  Product,
  makeUrl,
  AppLink,
  ProductCarouselConfig,
  TypeOptionConfig,
  categoryNormalize,
  ITheme,
  LocalWidgetConfig,
  StoreMetadata,
  TemplateType } from
"@commons-monorepo/index";
import { useTranslation } from "react-i18next";
import { ProductCard3 } from "../../../";
import { useLocation } from "react-router-dom";
import { UiButton } from "@ui-monorepo/index";
import { CallerEnum } from "../../../product-card/product-card.types";
import WidgetContainer from "../../../widget-container";
import Slider from "react-slick";
import { SliderArrowProps } from "../../../testimonials/testimonials.types";

const ProductsSliderSkin2: FC<{
  id: string;
  products: Product[];
  config: ProductCarouselConfig;
  log: () => void;
  theme: ITheme;
  localConfig: LocalWidgetConfig;
  storeMetadata: StoreMetadata;
}> = ({
  id,
  products: productList,
  config,
  log,
  localConfig,
  theme,
  storeMetadata
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const highLightBackground = config.highlight_background;

  const products = [...(productList || [])];

  const SliderArrow = ({ className, onClick }: SliderArrowProps) => {
    return (
      <UiButton
        appearance='icon'
        className={className || ""}
        leftIcon={<span className='icon-arrow-right' />}
        onClick={onClick}
        theme={theme} />);


  };

  const settings = {
    arrows: true,
    dots: false,
    infinite: products.length >= 4,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    variableWidth: false,
    prevArrow: <SliderArrow />,
    nextArrow: <SliderArrow />,
    responsive: [
    {
      breakpoint: 1023,
      settings: {
        infinite: products.length >= 3,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]

  };

  const goTo = (): string => {
    switch (config.filter_type) {
      case TypeOptionConfig.category:
        return makeUrl(
          pathname,
          `categoria/${categoryNormalize(config?.category || "")}`
        );
      default:
        return makeUrl(pathname, `todos-los-productos`);
    }
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLightBackground}>

      <article className={styles.productsSlider}>
        <header className={styles.header}>
          <h2 className={styles.title}>
            {config.filter_type === TypeOptionConfig.category ?
            `${config.category_name || config.category}` :
            config.display_name ? config.display_name : t("productsCarousel.title")}
          </h2>
          <AppLink onClick={log} to={goTo()}>
            <UiButton isSecondary className={styles.more} theme={theme}>
              {t("productsCarousel.button")}
            </UiButton>
          </AppLink>
        </header>
        <div className={styles.products}>
          <Slider {...settings}>
            {products?.map((product: Product, index: number) =>
            <div
              className={styles.slideItem}
              key={`${id}-productsSliderSkin2-${
              product.id
              }-${index}-${Math.random()}`}>

                <ProductCard3
                product={product}
                withTags={false}
                theme={{
                  ...theme,
                  template: {
                    ...theme.template,
                    PRODUCT_CARD: TemplateType.PRODUCT_CARD_3
                  }
                }}
                cartProducts={localConfig.cart.cartProducts}
                addProduct={localConfig.cart.addProduct}
                manuallyChangeProduct={localConfig.cart.manuallyChangeProduct}
                removeProduct={localConfig.cart.removeProduct}
                locale={localConfig.locale}
                currency={localConfig.currency}
                storeMetadata={storeMetadata}
                caller={CallerEnum.ProductCarousel} />

              </div>
            )}
          </Slider>
        </div>
        <footer className={styles.footer}>
          <AppLink onClick={log} to={goTo()}>
            <UiButton isSecondary className={styles.more} theme={theme}>
              {t("productsCarousel.button")}
            </UiButton>
          </AppLink>
        </footer>
      </article>
    </WidgetContainer>);

};
export default ProductsSliderSkin2;